import { notification } from 'antd';
import { get } from 'lodash';
import moment from 'moment';
/**
 * notifyAboutSaveError
 */
export const notifyAboutSaveError = (entityName: string, errors: any) => {
  notification.error({
    message: `${entityName} has not been saved.`,
    description: errors[0].messages.reduce((prev: string, curr: string) => prev + curr, ''),
  });
};

/**
 * notifyAboutDeleteError
 */
export const notifyAboutDeleteError = (entityName: string, errors: any) => {
  notification.error({
    message: `${entityName} has not been deleted.`,
    description: errors[0].messages.reduce((prev: string, curr: string) => prev + curr, ''),
  });
};

/**
 * handleSaveError
 */
export const handleSaveError = (
  entityName: string,
  operationName: string,
  successCallback: (payload: any) => void,
) => (data: any) => {
  const errors = get(data, `data.${operationName}.errors`, []);
  const payload = get(data, `data.${operationName}`, {});

  console.log('errors', errors, data);
  if (errors?.length) {
    notifyAboutSaveError(entityName, errors);
  } else {
    successCallback(payload);
  }
};

/**
 * handleDeleteError
 */
export const handleDeleteError = (
  entityName: string,
  mutationName: string,
  successCallback: () => void,
) => (data: any) => {
  const errors = get(data, `data.${mutationName}.errors`, []);

  if (errors?.length) {
    notifyAboutDeleteError(entityName, errors);
  } else {
    successCallback();
  }
};

/**
 * getBase64
 */
export const getBase64 = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

/**
 * getQueryResponseNodes
 */
export const getQueryResponseNodes = (list: { node: { [index: string]: any } }[]) => {
  return list.map(record => record.node);
};

/**
 * countWords
 */
export const countWords = (string: string) => {
  return string.split(/\s+/).length;
};

/**
 * isWordsLessThenEqual
 */
export const isWordsLessThenEqual = (wordsCount: number, maxWords: number) =>
  wordsCount <= maxWords;

/**
 * getWordsLeft
 */
export const getWordsLeft = (value: string, max: number) => {
  return value === '' ? max : max - countWords(value);
};

/**
 * safeOpenInNewTab
 */
export const safeOpenInNewTab = (url: any) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) {
    newWindow.opener = null;
  }
};

export const formatDate = (date: Date | string) => moment(date).format('DD.MM.YYYY');

export const formNumber = (value: number | bigint) =>
  new Intl.NumberFormat('de-DE', { maximumFractionDigits: 3 }).format(value);

export const validateTextLength = (value: string, max = 500) => {
  const isLengthInvalid = value.replace(/<\/?[^>]+(>|$)/g, '')?.length > max;
  if (isLengthInvalid) {
    return Promise.reject(`Der Text darf ${formNumber(max)} Zeichen nicht überschreiten`);
  } else {
    return Promise.resolve();
  }
};
